import styled from "styled-components";

/**
 * Wraps the ResourceManager so that:
 *   - Divider, SearchForm and ActionBar stay at their natural height (flex-shrink: 0)
 *   - The Ant Design table wrapper grows to fill remaining space
 *   - Only the table content (header + rows) scrolls internally, with the header sticky within it
 *   - Pagination is a normal-flow footer below the table content, so it never overlaps rows
 */
export const ResourceManagerWrapper = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    /* Prevent non-table children (Divider, SearchForm, ActionBar) from shrinking */
    & > * {
        flex-shrink: 0;
    }

    /* Table wrapper fills remaining space; its children below split scroll area vs. footer */
    & > .ant-table-wrapper {
        flex: 1 1 0;
        min-height: 150px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    /* Antd's internal wrappers (.ant-spin, .ant-spin-container, .ant-table, .ant-table-container) also need to be flex columns so pagination lays out below the table instead of via position: sticky */
    & > .ant-table-wrapper > .ant-spin,
    & > .ant-table-wrapper .ant-spin-container,
    & > .ant-table-wrapper .ant-table,
    & > .ant-table-wrapper .ant-table-container {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    /* The only scrollable region: table header + rows */
    & > .ant-table-wrapper .ant-table-content {
        flex: 1;
        min-height: 0;
        overflow: auto;
    }

    /* Stick the header row to the top of the scroll container */
    & > .ant-table-wrapper .ant-table-thead > tr > th,
    & > .ant-table-wrapper .ant-table-thead > tr > td {
        position: sticky;
        top: 0;
        z-index: 2;
        background: white;
    }

    /* Pagination sits below the table content in normal flow, never covering rows */
    & > .ant-table-wrapper .ant-table-pagination {
        flex-shrink: 0;
        background: white;
        padding: 10px 0;
        margin-bottom: 0;
    }
`;
